
<template lang="pug">
q-page.fit
  .absolute-full.column

    //- ツールバー
    .col-auto
      .flex.justify-between
        .flex.items-center.q-ma-xs

          //- 表示の切り替え
          q-btn.q-mx-xs(
            flat
            @click="onClickChangeAspect"
          ) 表示切替

          //- シフト作成
          q-btn.q-mx-xs(
            flat
            @click="onClickMakeShift"
          ) シフト初期化

          //- 印刷
          q-btn.q-mx-xs(
            flat
            @click="onClickPrint"
          ) 印刷

        .flex.items-center.justify-end.q-ml-auto.q-mr-xs

          //- //- 予測
          //- ShiftsEstimates(
          //-   ref="estimates"
          //-   :storeCode="storeCode"
          //-   :floorCode="floorCode"
          //-   :date="date"
          //-   @change="onChangeEstimates"
          //-   @refresh="refresh"
          //- )

    //- グリッド
    .col.grid
      .grid__table(
        v-show="steps.length"
        ref="table"
        :style="gridTableStyle"
        @mousedown.left.stop="onMouseDownScroll"
      )
        //- v-show="0 < cols.length && 0 < rows.length"

        .grid__thead

          //- コーナー
          .grid__corner-area
            .grid__tr
              .grid__corner(:style="cornerStyle0") 時
            .grid__tr
              .grid__corner(:style="cornerStyle0") 予測
            .grid__tr
              .grid__corner(:style="cornerStyle0") 余剰
            .grid__tr
              .grid__corner(:style="cornerStyle0") {{allSum|hour}}

              //- //- 種類別累計時間tip
              //- q-tooltip.app__tooltip(
              //-   :disable="typeSums.length === 0"
              //-   anchor="bottom middle"
              //-   self="top left"
              //- )
              //-   table
              //-     tr(v-for="type of typeSums")
              //-       td {{type.label}}
              //-       td ：
              //-       td.text-right {{type.sum|hour}}h

          //- 列ヘッダ
          .grid__column-header-area
            .grid__tr
              .grid__column-header.grid__left(
                v-for="col of colHours"
                :style="[colHeaderStyle0, {width: grid.cellW * col.colspan  + 'px'}]"
              ) {{col.text}}
            .grid__tr
              .grid__column-header.grid__center(
                v-for="col of colEstimates"
                :style="colHeaderStyle1"
              ) {{col|unit}}
            .grid__tr
              .grid__column-header.grid__center(
                v-for="col of colSurpluses"
                :style="colHeaderStyle1"
              ) {{col|unit}}
            .grid__tr
              .grid__column-header.grid__center(
                v-for="col of colAssignees"
                :style="colHeaderStyle1"
              ) {{col|unit}}

        //- 行ヘッダ
        .grid__row-header-area
          .grid__tr(v-for="(row, y) of rows")
            .grid__row-header.grid__left(:style="rowHeaderStyle0") {{row.text}}
            .grid__row-header.grid__center(:style="rowHeaderStyle1") {{row.textTime}}
            .grid__row-header(:style="rowHeaderStyle2") {{row.sumTime|hour}}

        //- セル
        .grid__cell-area
          //- ref="content"
          //- @contextmenu="onContextMenuDefault"

          grid-cells(
            :grid="grid"
            :rows="rows"
          )

          ShiftsItem(
            v-for="(shift, index) of shifts"
            :key="shift.id"
            :grid="grid"
            :beginStep="beginStep"
            :endStep="endStep"
            :dailyTasks="dailyTasks"
            :shifts="shifts"
            :index="index"
          )

    //-     //- コンテキストメニュー
    //-     ContextMenu(ref="contextMenu")

  //- //- 割当選択ポップアップ
  //- q-modal(
  //-   ref="assignmenu"
  //-   minimized
  //- )
  //-   q-list(
  //-     dense
  //-     highlight
  //-     v-close-overlay
  //-   )
  //-     q-list-header 割当を選択
  //-     q-item(
  //-       v-for="(assignee, index) of assignees"
  //-       :key="assignee.model.code" /* 注意: code は person_code または task_code のエイリアス */
  //-       @click.native="onSelectAssignMenu(index)"
  //-     )
  //-       q-item-main
  //-         q-item-tile {{assignee.model.label}}

</template>

<script>
import {get, range} from 'lodash-es'

import {stepFrom, stepFromCeil, stepFilter} from 'helpers/date'
import {mapAuto} from 'helpers/vuex-bind'
import DailyStore from 'models/DailyStore'
import DailyPerson from 'models/DailyPerson'
import DailyTask from 'models/DailyTask'
import Shift from 'models/Shift'

import ShiftsEstimates from './ShiftsEstimates'
import ContextMenu from 'components/ContextMenu'
import ShiftsItem from './ShiftsItem2'

import AxiosMixin from 'mixins/axios'
import GridBaseMixin from 'mixins/GridBaseMixin'
import ShiftsSum from './ShiftsSum'

export default {
  components: {ShiftsEstimates, ContextMenu, ShiftsItem},
  mixins: [AxiosMixin, GridBaseMixin, ShiftsSum],

  props: {
    storeCode: null,
    floorCode: null,
    date:      String,
    aspect:    String,
  },

  data() {
    return {
      grid: {
        cellW:     29,
        cellH:     25,
        headerW:  160,
        headerH:   25 * 4,
        paddingW:  20,
        paddingH:  20,
      },

      dailyStore: null,
      dailyPeople: [],
      dailyTasks: [],
      shifts: {},

      // columnHeaderStyle0: Object.freeze({height: '28px'}),
      // rowHeaderStyle0:    Object.freeze({width: '120px'}),
      // rowHeaderStyle1:    Object.freeze({width:  '40px'}),

      // store: null,
      // people: [],
      // tasks: [],
      // shifts: [],

      // rows: [],
      // assignees: [],
      // items: [],

      // estimates: [],

      dragging: null,
      itemFocused: null,
      // assignMenuCallback: null,
    }
  },

  computed: {
    ...mapAuto(['timeStepMinutes', 'stores']),

    cornerStyle0()    {return {...this.gridCornerStyle,       height: '25px'}},
    colHeaderStyle0() {return {...this.gridColumnHeaderStyle, height: '25px', paddingLeft: '8px'}},
    colHeaderStyle1() {return {...this.gridColumnHeaderStyle, height: '25px'}},
    rowHeaderStyle0() {return {...this.gridRowHeaderStyle,    width:  '60px'}},
    rowHeaderStyle1() {return {...this.gridRowHeaderStyle,    width:  '70px'}},
    rowHeaderStyle2() {return {...this.gridRowHeaderStyle,    width:  '30px'}},

    viewKey() {
      return Object.values(this.$props).some(v => v == null)
        ? null
        : this.storeCode + '/' + this.floorCode + '/' + this.date
    },

    beginStep() {
      return stepFrom(get(this.dailyStore, 'display_begin_time'))
    },

    endStep() {
      return stepFrom(get(this.dailyStore, 'display_end_time'))
    },

    steps() {
      return range(this.beginStep, this.endStep)
    },

    personIndices() {
      return this.dailyPeople.reduce((a, v, i) => ({...a, [v.person_code]: i}), {})
    },

    taskIndices() {
      return this.dailyTasks.reduce((a, v, i) => ({...a, [v.task_code]: i}), {})
    },

    colHours() {
      const colHours = []
      let step = this.beginStep
      if(step < this.endStep) {
        let colHour = {text: stepFilter(step, 'm'), colspan: 1}
        colHours.push(colHour)
        while(++step < this.endStep) {
          const text = stepFilter(step, 'm')
          if(text !== colHour.text) {
            colHour = {text, colspan: 1}
            colHours.push(colHour)
          }
          else {
            ++colHour.colspan
          }
        }
      }
      return colHours
    },

    colEstimates() {
      return this.steps.map(v => 'E' + v)
    },

    colSurpluses() {
      return this.steps.map(v => 'S' + v)
    },

    colAssignees() {
      return this.steps.map(v => v)
    },

    rows() {
      if(this.aspect != 'task') {

        // row (person apsect)
        return this.dailyPeople.map(dailyPerson => {
          const beginStep = stepFrom(dailyPerson.begin_time)
          const endStep   = stepFromCeil(dailyPerson.end_time)
          return {
            text:     dailyPerson.label,
            textTime: dailyPerson.timeLabel || '-',
            sumTime:  19.9,

            cells: this.steps.map(step => step < beginStep || endStep <= step
              ? {style: {backgroundColor: '#00000020'}}
              : {}
            ),
          }
        })
      }
      else {

        // row (task aspect)
        return this.dailyTasks.map(dailyTask => {
          const re = this.dailyStore['re' + dailyTask.type]
          return {
            text:     dailyTask.label,
            textTime: re ? 'RE ' + re : '-',
            sumTime:  28.8,

            cells: this.steps.map(() => ({})),
          }
        })
      }
    },

    items() {
      if(this.aspect != 'task') {

        // shift (person aspect)
        return Object.values(this.shifts).map(shift => {
          return {}
        })
      }
      else {

        // shift (task aspect)
        return Object.values(this.shifts).map(shift => {
          return {}
        })
      }
    },

  },

  watch: {
    viewKey() {
      this.refresh()
    },
  },

  mounted() {
    if(['person', 'task'].every(v => v != this.aspect)) {
      this.$store.commit('route', {params: {aspect: 'person'}})
    }
    this.refresh()

    //
    document.addEventListener('mousemove', this.onMouseMove)
    document.addEventListener('mouseup', this.onMouseUp)
  },

  beforeDestroy() {
    document.removeEventListener('mouseup', this.onMouseUp)
    document.removeEventListener('mousemove', this.onMouseMove)
  },

  methods: {

    async refresh() {
      try {
        if(this.viewKey != null) {

          // 表示を一旦クリアする
          this.dailyStore = null
          this.dailyPeople = []
          this.dailyTasks = []
          this.shifts = {}

          //
          const {data: dailyStores} = await this.axios.get('/api/daily_stores/' + this.viewKey)
          const {data: dailyPeople} = await this.axios.get('/api/daily_people/' + this.viewKey)
          const {data: dailyTasks } = await this.axios.get('/api/daily_tasks/'  + this.viewKey)
          const {data: shifts     } = await this.axios.get('/api/shifts/'       + this.viewKey)

          this.dailyStore  = new DailyStore(dailyStores[0])
          this.dailyPeople = DailyPerson.sortForShifts(dailyPeople.map(v => new DailyPerson(v)))
          this.dailyTasks  = DailyTask.sortForShifts(dailyTasks.map(v => new DailyTask(v)))
          this.shifts      = shifts.map(v => new Shift(v))
        }
      }
      catch(e) {this.$handler(e)}
    },

    //--------------------------------------------------------------------------
    // 基本マウスイベント

    onMouseDownScroll(e) {
      this.setItemFocus(null)
      const container = this.$refs.table.parentNode
      const offsetX = container.scrollLeft + e.screenX
      const offsetY = container.scrollTop + e.screenY
      this.dragging = {
        onMouseMove: e => {
          container.scrollLeft = offsetX - e.screenX
          container.scrollTop = offsetY - e.screenY
        },
      }
    },

    onMouseMove(e) {
      if(this.dragging && this.dragging.onMouseMove) {
        this.dragging.onMouseMove(e)
      }
    },

    onMouseUp(e) {
      if(this.dragging && e.button == 0) { // 左ボタンドラッグのみ対応
        if(this.dragging.onMouseUp) {
          this.dragging.onMouseUp()
        }
        this.dragging = null
      }
    },

    setItemFocus(item) {
      if(this.itemFocused) {
        this.itemFocused.state = null
      }
      if(this.itemFocused = item) {
        this.itemFocused.state = 'focus'
      }
    },


    // // コンテキストメニュー

    // onContextMenuDefault(e) {
    //   this.$refs.contextMenu.show(e, [{
    //     label: '予定を作成',
    //     onClick: () => {
    //       this.assignMenuCallback = index => {
    //         const rect     = this.$refs.content.getBoundingClientRect()
    //         const begin    = Math.floor((e.clientX - rect.left) / this.grid.cellW)
    //         const end      = begin + 2
    //         const row      = Math.floor((e.clientY - rect.top) / this.grid.cellH)
    //         const assignee = index
    //         this.insertItem({begin, end, row, assignee})
    //       }
    //       this.$refs.assignmenu.show()
    //     },
    //   }])
    // },

    // onContextMenuItem(e, item) {

    //   // CTRL+クリックでシフトを分割する (コンテキストメニューは開かない)
    //   if(e.ctrlKey) {
    //     return
    //   }

    //   //
    //   const options = []

    //   options.push({
    //     label: '割当を変更',
    //     onClick: () => {
    //       this.assignMenuCallback = index => {
    //         item.assignee = index
    //         this.updateItem(item)
    //       }
    //       this.$refs.assignmenu.show()
    //     },
    //   })

    //   const rect = this.$refs.content.getBoundingClientRect()
    //   const time = Math.floor((e.clientX - rect.left) / this.grid.cellW)
    //   if(item.begin < time && time < item.end - 1) {
    //     options.push({
    //       label: 'ここで分割',
    //       onClick: () => {
    //         this.insertItem({
    //           begin:    time + 1,
    //           end:      item.end,
    //           row:      item.row,
    //           assignee: item.assignee,
    //         })
    //         item.end = time
    //         this.updateItem(item)
    //       },
    //     })
    //   }

      // options.push({
      //   label: '予定を削除',
      //   onClick: async () => {
      //     try {
      //       await this.$q.dialog({
      //         title: '予定の削除',
      //         message: '予定を削除してよろしいですか？',
      //         ok: '削除する',
      //         cancel: 'キャンセル',
      //       })

      //       this.deleteItem(item)
      //     }
      //     catch(e) {this.$handler(e)}
      //   },
      // })

    //   this.$refs.contextMenu.show(e, options)
    // },

    // onSelectAssignMenu(index) {
    //   if(this.assignMenuCallback) {
    //     this.assignMenuCallback(index)
    //   }
    // },

    // // マウスイベント

    // onMouseDownItemMove(e, item) {

    //   // CTRL+クリックでシフトを分割する
    //   if(e.ctrlKey) {
    //     const rect = this.$refs.content.getBoundingClientRect()
    //     const time = Math.floor((e.clientX - rect.left) / this.grid.cellW)
    //     if(item.begin < time && time < item.end - 1) {
    //       this.insertItem({
    //         begin:    time + 1,
    //         end:      item.end,
    //         row:      item.row,
    //         assignee: item.assignee,
    //       })
    //       item.end = time
    //       this.updateItem(item)
    //     }
    //     return
    //   }

    //   //
    //   const rect = this.$refs.content.getBoundingClientRect()
    //   const offset = Math.floor((e.clientX - rect.left) / this.grid.cellW) - item.begin
    //   const width = item.end - item.begin
    //   this.dragging = {
    //     onMouseMove: e => {
    //       item.begin = clamp(Math.floor((e.clientX - rect.left) / this.grid.cellW) - offset, 0, this.cols.length - width)
    //       item.end = item.begin + width
    //       item.row = clamp(Math.floor((e.clientY - rect.top) / this.grid.cellH), 0, this.rows.length - 1)
    //     },
    //     onMouseUp: () => {
    //       this.updateItem(item)
    //     },
    //   }
    // },

    // onMouseDownItemResizeLeft(e, item) {
    //   const rectLeft = this.$refs.content.getBoundingClientRect().left
    //   this.dragging = {
    //     onMouseMove: e => {
    //       item.begin = clamp(Math.floor((e.clientX - rectLeft) / this.grid.cellW + .5), 0, item.end - 1)
    //     },
    //     onMouseUp: () => {
    //       this.updateItem(item)
    //     },
    //   }
    // },

    // onMouseDownItemResizeRight(e, item) {
    //   const rectLeft = this.$refs.content.getBoundingClientRect().left
    //   this.dragging = {
    //     onMouseMove: e => {
    //       item.end = clamp(Math.floor((e.clientX - rectLeft) / this.grid.cellW + .5), item.begin + 1, this.cols.length)
    //     },
    //     onMouseUp: () => {
    //       this.updateItem(item)
    //     },
    //   }
    // },


    // // DATA

    // async refresh() {
    //   try {
    //     // 表示を一旦クリアする
    //     this.people = []
    //     this.tasks = []

    //     //
    //     const {data} = await this.axios.get(
    //       '/api/views/shifts/' + this.storeCode + '/' + this.floorCode + '/' +  this.date)

    //     this.store = new DailyStore(data.dailyStore)

    //     // 個人の配列を作成する
    //     this.people = data.dailyPeople.map(person => {
    //       const model = new DailyPerson(person)

    //       // 個人の勤務時間に基づいてセル背景色を塗り分ける
    //       let cells
    //       if(model.isTimeValid) {
    //         cells = this.cols.map(step => stepFrom(model.begin_time) <= step && step < stepFromCeil(model.end_time) ? {} : disabledCell)
    //       }
    //       else {
    //         cells = this.cols.map(() => disabledCell)
    //       }

    //       return {model, cells}
    //     })

    //     // 行の配列を作成する
    //     // const estimates = this.$refs.estimates.makeEstimates(this.date, this.cols, data)

    //     this.tasks = data.tasks.map(task => {
    //       const model = new Task(task)

    //       // 予測に基づいてセル背景色を塗り分ける
    //       let cells
    //       // const re = data.dailyStore['re' + task.type]
    //       // if(re) {
    //       //   cells = this.cols.map((time, index) => {
    //       //     const disabled = estimates[index] <= 0
    //       //     estimates[index] -= re
    //       //     return disabled ? disabledCell : {}
    //       //   })
    //       // }
    //       // else {
    //         cells = this.cols.map(() => ({}))
    //       // }

    //       return {model, cells}
    //     })

    //     // 対象(シフト)の配列を作成する
    //     this.shifts = data.shifts.map(shift => {
    //       const {model: task, index: taskIndex} = this.taskMap[shift.task_code]
    //       return {
    //         id:     shift.id,
    //         person: this.personMap[shift.person_code].index,
    //         task:   taskIndex,
    //         begin:  stepFrom(shift.begin_time)   - this.displayBeginStep,
    //         end:    stepFromCeil(shift.end_time) - this.displayBeginStep,
    //       }
    //     })

    //     //
    //     this.updateItems()
    //   }
    //   catch(e) {this.$handler(e)}
    // },

    // // items配列を更新する
    // updateItems() {
    //   if(this.aspect != 'person') {
    //     this.rows = this.tasks
    //     this.assignees = this.people
    //   }
    //   else {
    //     this.rows = this.people
    //     this.assignees = this.tasks
    //   }

    //   this.items = this.shifts.map(
    //     this.aspect != 'person'
    //     ? (shift, index) => ({
    //       label:    this.assignees[shift.person].model.label,
    //       row:      shift.task,
    //       assignee: shift.person,

    //       id:       shift.id,
    //       begin:    shift.begin,
    //       end:      shift.end,
    //       state:    null,
    //       color:    null,
    //       index,

    //       get task() {return this.row}, //####
    //     })
    //     : (shift, index) => ({
    //       label:    this.assignees[shift.task].model.label,
    //       row:      shift.person,
    //       assignee: shift.task,

    //       id:       shift.id,
    //       begin:    shift.begin,
    //       end:      shift.end,
    //       state:    null,
    //       color:    null,
    //       index,

    //       get task() {return this.assignee}, //####
    //     })
    //   )

    //   if(this.itemFocused) {
    //     this.itemFocused = this.items.find(o => o.id === this.itemFocused.id)
    //     if(this.itemFocused) {
    //       this.itemFocused.state = 'focus'
    //     }
    //   }

    //   this.validateItems()
    // },

    // // items配列を検証して着色する
    // // TODO: shifts を deep watch したほうがよい？
    // validateItems() {
    //   const rows      = this.rows     .map(() => this.cols.map(() => []))
    //   const assignees = this.assignees.map(() => this.cols.map(() => []))
    //   for(const [i, item] of this.items.entries()) {
    //     const row      = rows     [item.row]
    //     const assignee = assignees[item.assignee]
    //     for(let t = item.begin; t < item.end; ++t) {
    //       row     [t].push(i)
    //       assignee[t].push(i)
    //     }
    //   }

    //   for(const item of this.items) {
    //     item.color =
    //          this.rows     [item.row     ].cells.slice(item.begin, item.end).find(o => o.disabled)
    //       || this.assignees[item.assignee].cells.slice(item.begin, item.end).find(o => o.disabled)
    //        ? 'warning'
    //        : null
    //   }

    //   for(const perspective of [rows, assignees]) {
    //     for(const cols of perspective) {
    //       for(const indices of cols) {
    //         if(1 < indices.length) {
    //           for(const i of indices) {
    //             this.items[i].color = 'error'
    //           }
    //         }
    //       }
    //     }
    //   }

    //   // 行/列の累計情報を作成する
    //   this.makeSums(this.cols, this.rows, this.items)
    //   this.makeTypeSums(this.tasks, this.shifts)
    // },

    // // item要素を新規作成する
    // makeShift({begin, end, row, assignee}) {
    //   return this.aspect != 'person'
    //     ? {
    //       begin,
    //       end,
    //       person: assignee,
    //       task: row,
    //     }
    //     : {
    //       begin,
    //       end,
    //       person: row,
    //       task: assignee,
    //     }
    // },

    // async insertItem(item) {
    //   try {
    //     const shift = this.makeShift(item)
    //     const apiData = {
    //       date:        this.date,
    //       store_code:  this.store.store_code,
    //       floor_code:  this.store.floor_code,
    //       begin_time:  stepToString(shift.begin + this.displayBeginStep),
    //       end_time:    stepToString(shift.end   + this.displayBeginStep),
    //       person_code: this.people[shift.person].model.person_code,
    //       task_code:   this.tasks [shift.task  ].model.task_code,
    //     }

    //     const {data: {id}} = await this.axios.post('/api/shifts', apiData)
    //     this.shifts.push({...shift, id})
    //     this.updateItems()
    //   }
    //   catch(e) {this.$handler(e)}
    // },

    // // item要素を更新する
    // async updateItem(item) {
    //   try {
    //     const modifier = this.makeShift(item)
    //     const modifiee = this.shifts[item.index]
    //     const apiData = {}
    //     for(const [prop, setApiData] of [
    //       ['begin',  v => {apiData.begin_time  = stepToString(v + this.displayBeginStep)}],
    //       ['end',    v => {apiData.end_time    = stepToString(v + this.displayBeginStep)}],
    //       ['person', v => {apiData.person_code = this.people[v].model.person_code}],
    //       ['task',   v => {apiData.task_code   = this.tasks [v].model.task_code  }],
    //     ]) {
    //       if(modifiee[prop] !== modifier[prop]) {
    //         modifiee[prop] = modifier[prop]
    //         setApiData(modifier[prop])
    //       }
    //     }
    //     if(Object.keys(apiData).length) {
    //       item.label = this.assignees[item.assignee].model.label
    //       this.validateItems()
    //       await this.axios.put('/api/shifts/' + item.id, apiData)
    //     }
    //   }
    //   catch(e) {this.$handler(e)}
    // },

    // // item要素を削除する
    // async deleteItem(item) {
    //   try {
    //     this.shifts.splice(item.index, 1)
    //     this.updateItems()
    //     await this.axios.delete('/api/shifts/' + item.id)
    //   }
    //   catch(e) {this.$handler(e)}
    // },

    // // 予測が変更された
    // onChangeEstimates(data) {
    //   this.estimates = data.estimates
    // },

    //--------------------------------------------------------------------------

    // 表示切替
    onClickChangeAspect() {
      this.$store.commit('route', {params: {aspect: this.aspect !== 'task' ? 'task' : 'person'}})
    },

    // シフト初期化
    async onClickMakeShift() {
      try {
        if(this.storeCode && this.floorCode && this.date) {
          await this.$q.dialog({
            title:   '確認',
            message: '稼働計画からシフトを作成します。現在のシフトはクリアされます。本当によろしいですか？',
            ok:      {label: '実行',       color: 'negative'},
            cancel:  {label: 'キャンセル', color: 'dark', flat: true},
          })

          await this.axios.put('/api/views/shifts/' + this.storeCode + '/' + this.floorCode + '/' +  this.date + '/make')

          this.refresh()
          await this.$q.dialog({
            title:   '完了',
            message: 'シフトの作成が完了しました。',
            ok:      'OK',
          })
        }
      }
      catch(e) {this.$handler(e)}
    },

    //- 印刷
    onClickPrint() {
      window.open('/api/views/shifts/' + this.storeCode + '/' + this.floorCode + '/' +  this.date + '/' +  this.date + '/print')
    },

  },
}
</script>

<style lang="sass">
// 赤色
.red
  color: red
</style>
